import { AnalyticsService } from "../../util/analytic/AnalyticsService";

const billingAnalytics = new AnalyticsService("Manage Subscriptions");

export default billingAnalytics;
